import React, { ReactElement } from 'react'
import { Box, Dropdown } from '@mindfulchefuk/design-system'
import { format } from 'date-fns'
import { CalendarContainer } from '@mindfulchefuk/features/Onboarding/components/Calendar/CalendarContainer'
import { TOnboardingRecipeFilterHandlers } from '@mindfulchefuk/onboarding/components/OnboardingChooseRecipes/OnboardingChooseRecipesFilters/OnboardingRecipeFilterHandlers.types'
import { RecipeFilter } from './RecipeFilter'

type TRecipeFilterCalendar = {
  onChange: TOnboardingRecipeFilterHandlers['date']
  onToggle: () => void
  date: string
  isOpen: boolean
}

export const DeprecatedRecipeFilterCalendar = ({
  date,
  onChange,
  onToggle,
  isOpen,
}: TRecipeFilterCalendar): ReactElement => {
  return (
    <Box>
      <RecipeFilter
        data-testid="recipe-filter-calendar"
        id="calendar"
        icon="calendar"
        label={format(date, 'dddd D MMM')}
        isOpen={isOpen}
        onToggle={onToggle}
      >
        <Dropdown
          data-testid="recipe-dropdown-calendar"
          isOpen={isOpen}
          onToggle={onToggle}
          alignment={['left', 'right', 'left']}
          maxWidth="316px"
          width={{ sm: '316px' }}
          py={0}
          px={0}
        >
          <CalendarContainer onDateChange={onChange} />
        </Dropdown>
      </RecipeFilter>
    </Box>
  )
}
